/**
 * Bellville Dental Tenant Configuration
 * Dental clinic appointment scheduling
 */

import type { TenantConfig } from './types';

export const bellviledentalConfig: TenantConfig = {
  tenant: 'BELLVILEDENTAL',
  displayName: 'Bellville Dental',

  calendar: {
    resourceTypes: ['CONFERENCE_ROOM', 'PERSON'],
    resourceGroups: [
      {
        type: 'CONFERENCE_ROOM',
        title: 'Stolice',
        icon: '🪑',
      },
      {
        type: 'PERSON',
        title: 'Doktori',
        icon: '👨‍⚕️',
      },
    ],
    defaultEventDuration: 30, // 30 minutes for dental appointments
    workingHours: {
      start: '08:00',
      end: '20:00',
    },
    timezone: 'Europe/Belgrade',
    availableViews: [
      '1day',
      '2day',
      '3day',
      '7day',
      'week-new',
      'month',
      'year',
      'year-agenda',
      'day-h-1h',
      'day-h-2d',
      'day-h-3d',
      'week-h',
    ],
    defaultView: 'week-new',
    features: {
      sunTimes: false,
      weather: false,
      dragAndDrop: true,
      realTimeUpdates: true,
      horizontalViews: true,
      yearView: true,
      yearAgendaView: true,
    },
  },

  eventTypes: [
    {
      value: 'checkup',
      label: 'Pregled',
      duration: 30,
      color: '#3498DB',
    },
    {
      value: 'cleaning',
      label: 'Čišćenje',
      duration: 45,
      color: '#2ECC71',
    },
    {
      value: 'filling',
      label: 'Plomba',
      duration: 60,
      color: '#F39C12',
    },
    {
      value: 'extraction',
      label: 'Vađenje',
      duration: 45,
      color: '#E74C3C',
    },
    {
      value: 'root_canal',
      label: 'Lečenje kanala',
      duration: 90,
      color: '#9B59B6',
    },
    {
      value: 'whitening',
      label: 'Izbeljivanje',
      duration: 60,
      color: '#1ABC9C',
    },
    {
      value: 'consultation',
      label: 'Konsultacija',
      duration: 20,
      color: '#95A5A6',
    },
    {
      value: 'implant',
      label: 'Implant',
      duration: 120,
      color: '#8E44AD',
    },
    {
      value: 'orthodontics',
      label: 'Ortodoncija',
      duration: 45,
      color: '#16A085',
    },
  ],

  metadataFields: [
    {
      key: 'patient_name',
      label: 'Pacijent',
      type: 'text',
      required: true,
    },
    {
      key: 'patient_phone',
      label: 'Telefon',
      type: 'phone',
      required: true,
    },
    {
      key: 'appointment_type',
      label: 'Tip termina',
      type: 'select',
      required: true,
      options: [
        { value: 'checkup', label: 'Pregled' },
        { value: 'cleaning', label: 'Čišćenje' },
        { value: 'filling', label: 'Plomba' },
        { value: 'extraction', label: 'Vađenje' },
        { value: 'root_canal', label: 'Lečenje kanala' },
        { value: 'whitening', label: 'Izbeljivanje' },
        { value: 'consultation', label: 'Konsultacija' },
        { value: 'implant', label: 'Implant' },
        { value: 'orthodontics', label: 'Ortodoncija' },
      ],
    },
    {
      key: 'notes',
      label: 'Napomene',
      type: 'textarea',
    },
  ],

  locale: {
    language: 'sr',
    dateFormat: 'D. MMM YYYY',
    timeFormat: 'HH:mm',
  },
};
